import { render } from "./SecretWord.vue?vue&type=template&id=22531845"
import script from "./SecretWord.vue?vue&type=script&lang=js"
export * from "./SecretWord.vue?vue&type=script&lang=js"

import "./SecretWord.vue?vue&type=style&index=0&id=22531845&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__